import React from "react";
import { SectieKop, LIJST } from "@/components/rust/Rust";
import { cap } from "@/components/afspraken/afsprakenUtils";

const DAG = ["ma", "di", "wo", "do", "vr"];
const CHIP = "shrink-0 text-[11px] font-semibold px-2 py-0.5 rounded-full border";
const STATUS_KLEUR = { besproken: "bg-emerald-50 text-emerald-700 border-emerald-200", "nog-niet": "bg-amber-50 text-amber-700 border-amber-200", gepland: "bg-zinc-50 text-zinc-600 border-zinc-200" };

// v19-B3: links alle actieve afdelingen, met overlegdag, open/te laat en de status van deze week.
export const AfdelingLijst = ({ data, gekozen, onKies }) => (
  <div data-testid="afdelingen-lijst">
    <SectieKop titel="Afdelingen" aantal={data.afdelingen.length} hint={`week ${Number(data.week.slice(-2))}`} />
    <ul className={LIJST}>
      {data.afdelingen.map((a) => (
        <li key={a.id}>
          <button type="button" data-testid={`afdeling-${a.id}`} aria-current={gekozen === a.id} onClick={() => onKies(a.id)}
            className={`w-full text-left px-3 py-2.5 flex items-start justify-between gap-2 transition-colors ${gekozen === a.id ? "bg-zinc-100 border-l-[3px] border-zinc-950" : "hover:bg-zinc-50"}`}>
            <span className="min-w-0">
              <span className="block text-[13.5px] font-semibold text-zinc-900">{a.naam}</span>
              <span className="block text-xs text-zinc-500">{a.leden.length ? a.leden.map(cap).join(", ") : "nog geen account"} · overleg {DAG[a.overlegDag] || "–"}</span>
              <span data-testid={`afdeling-${a.id}-tellers`} className="block font-mono text-[11px] text-zinc-500 mt-0.5">
                {a.open} open · <span className={a.teLaat ? "text-rose-600 font-bold" : ""}>{a.teLaat} te laat</span>
              </span>
            </span>
            <span data-testid={`afdeling-${a.id}-status`} className={`${CHIP} ${STATUS_KLEUR[a.status]}`}>{a.statusLabel}</span>
          </button>
        </li>
      ))}
    </ul>
  </div>
);
